module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Preface")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It has been the wish of many surviving members of StuG Brigade 191 to have a cohesive documentary record of their experiences in the war years 1941 to 1945. This publication completes the work begun by the first commanding officer of our Abteilung, the late Generalmajor Günter Hoffmann-Schoenborn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The aim of this book is to present in a simple format the development of the self-propelled assault gun described herein, to make its tactical significance clearly recognizable and to honour the achievements of the members of our Abteilung.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The background is set down factually with the reports and personal experiences of our men being built into the text. Unfortunately, many documents, particularly action reports, were not available and I was obliged to put together the brigade history from anecdotes, war communiqués, the published literature and personal accounts. It has also proved difficult to obtain photographs suitable for use.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If this record can be a memorial to the men of our brigade who fell, then I believe that this brigade history will have fulfilled its purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "right5"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bruno Bork,"), _c('br'), _vm._v("December 1977")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Note to the 2009 Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After the death of the author of the original chronicle several years ago, two former brigade members supplied photographs which provided the incentive for this expanded new edition. Frau Bork delivered some previously unpublished photographs from her husband’s literary estate so that the volume is now richly illustrated. Our very grateful thanks go to Hermann Röhm and Pacco Hofmann for making the photographs available.")]), _vm._v(" "), _c('p', {
    staticClass: "right5"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Publishers,"), _c('br'), _vm._v("August 2009")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60cc67fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Preface.vue
// module id = 69
// module chunks = 0